export enum HeaderCatalogVariants {
  SIZE_ICON = 24,
  COLOR_ICON = '$backgroundAltPrimary',
}
